// @ts-strict-ignore
import {AnyAttrs, AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {toCurrency} from 'media/js/pricing/plan-builder-2023/common/util';
import type {PlanBuilder} from 'media/js/pricing/plan-builder-2023/index';
import {PlanBuilderState} from 'media/js/pricing/plan-builder-2023/types';
import {getOwnerAccounts} from 'media/js/pricing/api/api';
import {TrackingEvents} from 'media/js/pricing/tracking';

import {template} from './template';
import './index.styl';

type FeaturePackageOptionsState = {
  owners: Array<{[key: string]: any}>;
};

export class FeaturePackageOptions extends Component<
  FeaturePackageOptionsState,
  AnyAttrs,
  PlanBuilderState,
  PlanBuilder
> {
  static get attrsSchema(): AttrsSchema<AnyAttrs> {
    return {
      ...super.attrsSchema,
      unauthed: `boolean`,
      'mp-2023-style': {
        type: `boolean`,
        description: `flag to check whether page should apply new 2023 stying`,
      },
    };
  }

  get config() {
    return {
      template,
      defaultState: {
        owners: null,
      },
      helpers: {
        handlePackageClick: (packageId) => {
          const packageIds = new Set(this.app.helpers.getSelectedPlanState().packageIds);
          if (packageIds.has(packageId)) {
            packageIds.delete(packageId);
            this.app.helpers.trackEventWithPlanProps(TrackingEvents.PackageRemoved);
          } else {
            packageIds.add(packageId);
            this.app.helpers.trackEventWithPlanProps(TrackingEvents.PackageAdded);
          }

          this.app.helpers.handleChangeSelectedPlan({packageIds: Array.from(packageIds)});
        },
        toCurrency,
        handleContinue: () => {
          if (this.attr(`unauthed`)) {
            window.location.href = `/signup/?next=${encodeURIComponent(location.pathname)}`;
          } else {
            this.app.helpers.goToNextStep();
          }
        },
        userLacksBillingPermissions: () => {
          return !this.attr(`unauthed`) && !this.app.state?.customerInfo?.orgInfo?.hasBillingPermissions;
        },
      },
    };
  }

  public async connectedCallback() {
    super.connectedCallback();

    if (this.helpers.userLacksBillingPermissions()) {
      this.update({owners: await getOwnerAccounts(this.app.state.customerInfo.orgInfo.orgId, {count: 3})});
    }
  }
}

export const FeaturePackageOptionsEl = defineAndMakeJsxFactory(`feature-package-options-2023`, FeaturePackageOptions);
